import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import { products, getProductCategories } from "../../data/products";
import "./RelatedProducts.scss";

// Editorial selections reference canonical catalog records, keeping names and
// categories in sync with the products used throughout the site.
export default function RelatedProducts({ productSlugs = [], headingId = "related-products-heading" }) {
  const related = [...new Set(productSlugs)].map((slug) => (
    products.find((product) => product.slug === slug)
  )).filter(Boolean).slice(0, 4);

  if (!related.length) return null;

  return (
    <section className="editorial-related-products" aria-labelledby={headingId}>
      <h2 id={headingId}>Related Products</h2>
      <ul>
        {related.map((product) => (
          <li key={product.slug}>
            <Link to={`/products/${product.slug}`}>
              <span>
                <strong>{product.name}</strong>
                <small>{getProductCategories(product).map(({ name }) => name).join(" · ")}</small>
              </span>
              <FiArrowRight aria-hidden="true" />
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
